import { Component, Input, OnInit } from '@angular/core'
import { Application } from 'src/app/account/services/application.service'
import {
  S3BucketReplicationNotConfiguredIssue,
  UnconfiguredS3BucketReplicationIssue,
} from 'src/app/account/services/issue'
import { SyncPair } from 'src/app/account/services/sync-pair.service'
import { UiService } from 'src/app/services/ui.service'
import { ViewableIssue } from '../../issues-view/issues-view.component'
import { CopyFeedbackService } from 'src/app/shared/copy-feedback.service'

@Component({
  selector: 'unconfigured-bucket-replication-issue',
  templateUrl: './unconfigured-bucket-replication-issue.component.html',
  styleUrls: ['./unconfigured-bucket-replication-issue.component.scss'],
  standalone: false,
  providers: [CopyFeedbackService],
})
export class UnconfiguredBucketReplicationIssueComponent implements OnInit {
  @Input() issue: ViewableIssue = null
  @Input('sync-pair') syncPair: SyncPair = null
  @Input('application') application: Application = null

  private _currentTab: string
  constructor(
    public uiService: UiService,
    public copyFeedback: CopyFeedbackService
  ) {
    this._currentTab = 'console' // start view on the AWS console instructions
  }

  ngOnInit(): void {}

  showTab(tabName: string) {
    this._currentTab = tabName
  }

  private get unconfiguredReplicationIssue() {
    return this.issue.issue as S3BucketReplicationNotConfiguredIssue
  }

  get currentTab() {
    return this._currentTab
  }

  get destinationBucketArn() {
    return this.unconfiguredReplicationIssue.targetBucketArn
  }

  private lastMember<T>(arr: Array<T>): T {
    return arr[arr.length - 1]
  }
  get destinationBucketName() {
    return this.lastMember(this.destinationBucketArn.split(':'))
  }

  get replicationIamRoleArn() {
    return this.unconfiguredReplicationIssue.replicationIamRole
  }

  get replicationIamRoleName() {
    return this.lastMember(this.replicationIamRoleArn.split('/'))
  }

  get sourceBucketName() {
    return this.unconfiguredReplicationIssue.sourceBucketName
  }

  get kmsKeyArn() {
    return this.unconfiguredReplicationIssue.kmsKeyArn
  }

  get targetAccount() {
    return this.syncPair.targetAwsAccountId
  }
}
